import { Button, Popup } from '@approvalmax/ui/src/components';
import { FC, memo, useCallback } from 'react';
import { useToggle } from 'react-use';

import { PopupContent } from './components';
import { StyledVideoIcon, ThumbnailArea } from './VideoPopup.styles';
import { VideoPopupProps } from './VideoPopup.types';

export const VideoPopup: FC<VideoPopupProps> = memo((props) => {
    const { imgSrc, videoSrc, title, onWatchingCounted, onOpen } = props;

    const [isShowPopup, toggleIsShowPopup] = useToggle(false);

    const handleOpen = useCallback(() => {
        toggleIsShowPopup(true);
        onOpen?.();
    }, [toggleIsShowPopup, onOpen]);

    return (
        <>
            <Button noPadding onClick={handleOpen} variant='text' color='blue100'>
                <ThumbnailArea>
                    <img width='300' height='169' src={imgSrc} alt={title} />

                    <StyledVideoIcon size={40} />
                </ThumbnailArea>
            </Button>

            <Popup open={isShowPopup} onToggle={toggleIsShowPopup} size='large'>
                <PopupContent videoSrc={videoSrc} title={title} onWatchingCounted={onWatchingCounted} />
            </Popup>
        </>
    );
});

VideoPopup.displayName = 'VideoPopup';
